import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

/**
 * Legacy payload structure for backwards compatibility.
 * Used by the existing ABComparisonView in location alarm details.
 */
export interface ABFeedbackPayloadLegacy {
  feature: string;
  feedback: Record<string, unknown>;
}

/**
 * New payload structure for alarm-review flow.
 * Includes ab_inference_server_alarm_id and top-level feedback fields.
 */
export interface ABFeedbackPayloadNew {
  feature: string;
  ab_inference_server_alarm_id: number;
  tags_same: boolean;
  bounding_boxes_same: boolean;
  comment?: string;
}

export type ABFeedbackPayload = ABFeedbackPayloadLegacy | ABFeedbackPayloadNew;

export interface ABFeedbackResponse {
  id: number;
  user_email: string;
  feature: string;
  feedback: Record<string, unknown>;
  ab_inference_server_alarm_id?: number;
  tags_same?: boolean;
  bounding_boxes_same?: boolean;
  comment?: string;
  created_at_utc: string;
}

export function useABFeedback(onSuccess?: (data: ABFeedbackResponse) => void) {
  const url = `/v2/orm/ab/feedback`;

  const request = new Request(url, {
    method: 'POST',
  });

  return useAuthenticatedMutation<ABFeedbackResponse, ABFeedbackPayload>(
    request,
    {
      onSuccessInvalidationKeys: [['alarms-for-review']],
      onSuccess,
      responseModifier: async (response) => {
        const respJson = await response.json();
        return respJson.payload;
      },
    }
  );
}

export default useABFeedback;
